import E3DLogoutModal from './E3DLogoutModal'
import E3DLogoutModalContainer from './E3DLogoutModalContainer'

export { E3DLogoutModal, E3DLogoutModalContainer }
export default E3DLogoutModal 